import type { SchemaProp } from '@based'

export const createdAt = {
  type: 'timestamp',
  on: 'create',
} as const satisfies SchemaProp

export const createdBy = (prop: string): SchemaProp => ({
  ref: 'user',
  prop,
})

export const updatedAt = {
  type: 'timestamp',
  on: 'update',
} as const satisfies SchemaProp

// to get an array of roles use `Object.values(roles)`
export const userRoles = {
  Admin: 'admin',
  Viewer: 'viewer',
  UkViewer: 'ukViewer',
  Translator: 'translator',
} as const

export const userRolesDescriptions = {
  [userRoles.Admin]: {
    label: 'Admin',
    description: 'Can edit anything on the workspace and manage other members',
  },
  [userRoles.Viewer]: {
    label: 'Viewer',
    description: 'Can only view results',
  },
  [userRoles.UkViewer]: {
    label: 'UK Viewer',
    description: 'Can only view UK results',
  },
  [userRoles.Translator]: {
    label: 'Translator',
    description: 'Can edit translations', // Needs better description
  },
} as const

export const userStatuses = {
  Active: 'active',
  Inactive: 'inactive',
  Pending: 'pending',
  Onboarding: 'onboarding',
} as const

export const html = {
  type: 'string',
  localized: true,
  format: 'html',
} as const satisfies SchemaProp
